export const routeDateFormat = 'yyyy-MM-dd';
export const routeMonthFormat = 'yyyy-MM';